import './App.css';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ReactNode, useEffect } from 'react';
import Home from './pages/home';
import About from './pages/about';
import Soilcast from './pages/soilcast';
import Spoat from './pages/spoat';
import BeCharge from './pages/becharge';
import ScrollToTop from './scrollToTop';
import ContactPage from './pages/contact';
import PortfolioPage from './pages/portfolio';
import Brembo from './pages/brembo';
import MXE from './pages/mxe';

function App() {

  return (
    <HashRouter>
      <ScrollToTop>
         <Routes>
          <Route index element={<Home />} />
          <Route path='/about' index element={<About />} />
          <Route path='/soilcast' index element={<Soilcast />} />
          <Route path='/spoat' index element={<Spoat />} />
          <Route path='/brembo' index element={<Brembo />} />
          <Route path='/mxe' index element={<MXE />} />
          <Route path='/becharge' index element={<BeCharge />} />
          <Route path='/contact' index element={<ContactPage />} />
           <Route path='/portfolio' index element={<PortfolioPage />} />
        </Routes>
      </ScrollToTop>
    </HashRouter>
  );
}

export default App;
